// extracted by mini-css-extract-plugin
export default {"comment":"comment_comment__Ap4Kh","containerInput":"comment_containerInput__AKspj","bottom":"comment_bottom__YJYHU"};